import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';
import { Col, Row, Typography, Collapse, Tooltip } from 'antd';
import styles from './enrichment.module.sass';
import cx from 'classnames';
import ScoreBadge from '../../../../shared-components/ScoreBadge';
import EnrichmentTopBar from '../EnrichmentTopBar';
import EnrichmentIpInformation from '../EnrichmentIpInformation';
import EnrichmentDnsRecords from '../EnrichmentDnsRecords';
import EnrichmentGeo from '../EnrichmentGeo';
import EnrchmentAssociatedCert from '../EnrichmentAssociatedCert';
import EnrichmentCuratedFeedHistory from '../EnrichmentCuratedFeedHistory';
import EnrichmentAsnInformation from '../EnrichmentAsnInformation';
import EnrichmentSubnetInformation from '../EnrichmentSubnetInformation';
import EnrichmentCustomAttributes from '../EnrichmentCustomAttributes';
import EnrichmentSources from '../EnrichmentSources';
import EnrichmentWhoisInformation from '../EnrichmentWhoisInformation';
import EnrichmentDomainInformation from '../EnrichmentDomainInformation';
import EnrichmentIpDiversity from '../EnrichmentIpDiversity';
import EnrichmentNameServerChanges from '../EnrichmentNameServerChanges';
import EnrichmentNameServerInformation from '../EnrichmentNameServerInformation';
import EnrichmentCertificates from '../EnrichmentCertificates';
import EnrichmentHeader from '../EnrichmentHeader';
import EnrichmentHtml from '../EnrichmentHtml';
import EnrichmentJarm from '../EnrichmentJarm';
import EnrichmentFavicon from '../EnrichmentFavicon';
import { BackButton } from '../../../../shared-components/BackButton';
import { STATUS } from '../../../../redux/constants';
import EnrichmentIPReputation from '../EnrichmentIPReputation';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import EnrichmentSnapshot from '../EnrichmentSnapshot';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

function Enrichment(props) {
  const {
    mergeAPIEnrichment: mergeAPIEnrichmentData,
    enrichmentStatus,
    mergeAPINewEnrichment: mergeAPINewEnrichmentData,
    parsedIOC,
    parsedIOCStatus,
    newEnrichmentStatus,
    exploreAPIwhoisDetails: whoisData,
    exploreAPIwhoisFallbackDetails: whoisFallbackData,
    whoisStatus,
    whoisFallbackStatus,
    dnsRecords: dnsRecords,
    dnsRecordsStatus,
    ARecordsDomainEnrichmentData,
    ARecordsDomainEnrichmentStatus,
    AAAARecordsDomainEnrichmentData,
    AAAARecordsDomainEnrichmentStatus,
    CNAMERecordsDomainEnrichmentData,
    CNAMERecordsDomainEnrichmentStatus,
    MXRecordsDomainEnrichmentData,
    MXRecordsDomainEnrichmentStatus,
    NSRecordsDomainEnrichmentData,
    NSRecordsDomainEnrichmentStatus,
    SOARecordsDomainEnrichmentData,
    SOARecordsDomainEnrichmentStatus,
    TXTRecordsDomainEnrichmentData,
    TXTRecordsDomainEnrichmentStatus,
    domainInfraTags,
    infraTagStatus,
    ipDensityEnrichment: ipDensityEnrichment,
    ipDensityEnrichmentStatus: ipDensityEnrichmentStatus,
    ptrLookupEnrichment: ptrLookupEnrichment,
    ptrLookupEnrichmentStatus: ptrLookupEnrichmentStatus,

    //used in EnrichmentSources through props
    checkEnrichmentFeedHasBlogs,
    resetEnrichmentFeedHasBlogsState,
    enrichedIOCFeedBlogs: enrichedIOCFeedBlogs,
    enrichedIOCFeedBlogsStatus: enrichedIOCFeedBlogsStatus,
    availableFeeds: availableFeeds,
    availableFeedsStatus: availableFeedsStatus,
  } = props;

  const { Title, Text, Paragraph } = Typography;
  const { Panel } = Collapse;
  const dispatch = useDispatch();
  let scanDate;

  dispatch(changeTitle('Enrichment'));

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const q = useQuery();
  const [type, setType] = useState(q?.get('type'));
  const [activeCollapseKey, setActiveCollapseKey] = useState([
    '1',
    '2',
    '3',
    '4',
  ]);

  const openAllCollapse = () => {
    setActiveCollapseKey(['1', '2', '3', '4']);
  };

  const toggleCollapse = (key) => {
    if (activeCollapseKey?.includes(key)) {
      setActiveCollapseKey(activeCollapseKey?.filter((k) => k !== key));
    } else {
      setActiveCollapseKey([...activeCollapseKey, key]);
    }
  };

  const loadDomainEnrichment = (domain) => {
    props.loadMergeAPINewEnrichment({
      name: domain,
      iocType: 'domain',
    });
    // props.loadDnsRecords({
    //   path: `padns/snapshot/domain/${domain}`,
    // });

    props.loadMergeAPIDomainInfraTags(domain, 0);
    props.loadMergeAPIWhoisDetails(
      '/domain/whoislive/' + domain + '?origin_uid=ENRICHMENT&is_voluntary=0',
    );
    props.loadMergeAPIWhoisFallbackDetails(
      '/domain/whois/' + domain + '?origin_uid=ENRICHMENT&is_voluntary=0',
    );
    props.loadARecordsDomainEnrichment({
      path:
        'padns/lookup/query/a/' +
        domain +
        '?origin_uid=ENRICHMENT&is_voluntary=0',
    });
    props.loadAAAARecordsDomainEnrichment({
      path:
        'padns/lookup/query/aaaa/' +
        domain +
        '?origin_uid=ENRICHMENT&is_voluntary=0',
    });
    props.loadCNAMERecordsDomainEnrichment({
      path:
        'padns/lookup/query/cname/' +
        domain +
        '?origin_uid=ENRICHMENT&is_voluntary=0',
    });
    props.loadMXRecordsDomainEnrichment({
      path:
        'padns/lookup/query/mx/' +
        domain +
        '?origin_uid=ENRICHMENT&is_voluntary=0',
    });
    props.loadNSRecordsDomainEnrichment({
      path:
        'padns/lookup/query/ns/' +
        domain +
        '?origin_uid=ENRICHMENT&is_voluntary=0',
    });
    props.loadSOARecordsDomainEnrichment({
      path:
        'padns/lookup/query/soa/' +
        domain +
        '?origin_uid=ENRICHMENT&is_voluntary=0',
    });
    props.loadTXTRecordsDomainEnrichment({
      path:
        'padns/lookup/query/txt/' +
        domain +
        '?origin_uid=ENRICHMENT&is_voluntary=0',
    });
    setTimeout(() => {
      props.loadMySubscriptionLimit();
    }, 2000);
  };

  const loadIPEnrichment = (ip) => {
    props.loadMergeAPINewEnrichment({ name: ip, iocType: 'ipv4' });
    props.loadIpDensity({ ip: ip, iocType: 'ipv4', is_voluntary: 0 });
    props.loadPTRLookup({ ip: ip, iocType: 'ptr4', is_voluntary: 0 });
    setTimeout(() => {
      props.loadMySubscriptionLimit();
    }, 2000);
  };

  useEffect(() => {
    return () => {
      props.resetEnrichment();
    };
  }, []);

  useEffect(() => {
    if (props.mySubscriptionPlanStatus === STATUS.LOADED) {
      if (props.mySubscriptionPlan?.has_access_to_sources) {
        props.loadSources();
      }
    }
  }, [props.mySubscriptionPlanStatus]);

  useEffect(() => {
    window.scrollTo(0, 0);
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.resetEnrichment();
    document.title = 'Enrichment - Silent Push';

    //we call the parsing tool to get the base every time, used e.g. in associated cert's. URL types need to pass the base host or IP to that query.
    props.loadUtilsParseIOC({ ioc: q?.get('name') });

    incrementUIRequestsCounter();
  }, [window.location.search]);

  useEffect(() => {
    if (parsedIOCStatus === STATUS.LOADED) {
      //this is domain, not URL - domain. For URLs, we only call the enrichment after we determined if it's IP or Domain base. As the "new" enrichment calls only work on IPs and domains.
      if (parsedIOC?.type === 'domain' && parsedIOC?.type !== 'url') {
        loadDomainEnrichment(q?.get('name'));
      }
      //this is IP type, not URL - IP. For URLs, we only call the enrichment after we determined if it's IP or Domain base. As the "new" enrichment calls only work on IPs and domains.
      if (parsedIOC?.type === 'ipv4' && parsedIOC?.type !== 'url') {
        loadIPEnrichment(q?.get('name'));
      }

      if (type === 'ip' && parsedIOC?.type === 'url') {
        loadIPEnrichment(parsedIOC?.result);
      }
      if (type === 'domain' && parsedIOC?.type === 'url') {
        loadDomainEnrichment(parsedIOC?.result);
      }

      //type is used throughout enrichment to determine if the base is IP or Domain, even if the main type of the IOC is URL.

      setType(q?.get('type') === 'ip' ? 'ipv4' : 'domain');

      //this is the "old" enrichment call, used to get basic information of the IOC. It works for URLs as well as domains and IPs.
      props.loadMergeAPIEnrichment({
        ioc: parsedIOC?.result,
        type: q?.get('type'),
      });

      //Loading subscription plan again to get count, to see if we need to display modal
    }
  }, [parsedIOCStatus]);

  useEffect(() => {
    if (parsedIOCStatus === STATUS.LOADED) {
      //this is only for URLs
      if (
        mergeAPIEnrichmentData?.ioc_template == 'domain' &&
        mergeAPIEnrichmentData?.type === 'url'
      ) {
        loadDomainEnrichment(parsedIOC?.['result']);
      } else if (
        mergeAPIEnrichmentData?.ioc_template == 'ip' &&
        mergeAPIEnrichmentData?.type === 'url'
      ) {
        loadIPEnrichment(parsedIOC?.['result']);
      }
    }
  }, [parsedIOCStatus]);

  useEffect(() => {
    if (newEnrichmentStatus === STATUS.LOADED) {
      if (mergeAPIEnrichmentData?.ioc_template === 'domain') {
        if (mergeAPINewEnrichmentData?.response?.scan_data?.certificates) {
          scanDate =
            mergeAPINewEnrichmentData.response?.scan_data?.certificates?.[0]
              ?.scan_date;
        }
      } else if (mergeAPIEnrichmentData?.ioc_template === 'ip') {
        if (mergeAPINewEnrichmentData?.response?.ip2asn) {
          if (
            mergeAPINewEnrichmentData?.response?.ip2asn?.[0]?.scan_data
              ?.certificates
          ) {
            scanDate =
              mergeAPINewEnrichmentData?.response?.ip2asn?.[0]?.scan_data
                ?.certificates?.[0]?.scan_date;
          }
        }
      }
    }
  }, [newEnrichmentStatus]);

  function infoAttributesHeader() {
    return (
      <div
        className={cx(styles.header, styles.only_text_header)}
        onClick={() => toggleCollapse('1')}
      >
        <Title level={4} className={styles.title}>
          Information
        </Title>
      </div>
    );
  }

  function attributesHeader() {
    return (
      <div className={styles.header} onClick={() => toggleCollapse('2')}>
        <Tooltip
          title={
            <Paragraph className="m-0">
              A cumulative score that includes all data and scores from each
              enriched attribute
            </Paragraph>
          }
        >
          <Text className={styles.empty_text}>&nbsp;</Text>
          <ScoreBadge
            score={
              mergeAPIEnrichmentData?.total_ioc
                ? mergeAPIEnrichmentData?.total_ioc
                : 0
            }
            scoreTextRecolor={false}
            scoreProgressRecolor={false}
            boxBordered={false}
          />
        </Tooltip>
        <Title level={4} className={styles.title}>
          Enriched Attributes
        </Title>
      </div>
    );
  }

  function sourcesHeader() {
    return (
      <div className={styles.header} onClick={() => toggleCollapse('3')}>
        <Tooltip
          title={
            <>
              <Paragraph>
                A score calculated by sources attributes (that you see in threat
                ranking details or enriched data)
              </Paragraph>
              <Paragraph className="m-0">
                A source score can be added during the creation of the source
                (feed or collection), or any time the user edits a source
              </Paragraph>
            </>
          }
        >
          <Text className={styles.empty_text}>&nbsp;</Text>
          <ScoreBadge
            score={
              mergeAPIEnrichmentData?.total_feed
                ? mergeAPIEnrichmentData?.total_feed
                : 0
            }
            scoreTextRecolor={false}
            scoreProgressRecolor={false}
            boxBordered={false}
          />
        </Tooltip>
        <Title level={4} className={styles.title}>
          Live Threat Feeds
        </Title>
      </div>
    );
  }
  function scanDataHeader() {
    return (
      <div
        className={cx(styles.header, styles.only_text_header)}
        onClick={() => toggleCollapse('4')}
      >
        <Title level={4} className={styles.title}>
          {scanDate ? `Scan Data as of ${scanDate}` : 'Scan Data'}
        </Title>
      </div>
    );
  }

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    props.mySubscriptionPlan?.has_access_to_enrich ? (
      <div className={styles.enrichment}>
        <BackButton />
        <EnrichmentTopBar
          oldData={mergeAPIEnrichmentData}
          statusOld={enrichmentStatus}
          newData={mergeAPINewEnrichmentData}
          statusNew={newEnrichmentStatus}
          ARecordsDomainEnrichmentData={ARecordsDomainEnrichmentData}
          ARecordsDomainEnrichmentStatus={ARecordsDomainEnrichmentStatus}
          AAAARecordsDomainEnrichmentData={AAAARecordsDomainEnrichmentData}
          AAAARecordsDomainEnrichmentStatus={AAAARecordsDomainEnrichmentStatus}
          CNAMERecordsDomainEnrichmentData={CNAMERecordsDomainEnrichmentData}
          CNAMERecordsDomainEnrichmentStatus={
            CNAMERecordsDomainEnrichmentStatus
          }
          MXRecordsDomainEnrichmentData={MXRecordsDomainEnrichmentData}
          MXRecordsDomainEnrichmentStatus={MXRecordsDomainEnrichmentStatus}
          NSRecordsDomainEnrichmentData={NSRecordsDomainEnrichmentData}
          NSRecordsDomainEnrichmentStatus={NSRecordsDomainEnrichmentStatus}
          SOARecordsDomainEnrichmentData={SOARecordsDomainEnrichmentData}
          SOARecordsDomainEnrichmentStatus={SOARecordsDomainEnrichmentStatus}
          TXTRecordsDomainEnrichmentData={TXTRecordsDomainEnrichmentData}
          TXTRecordsDomainEnrichmentStatus={TXTRecordsDomainEnrichmentStatus}
          whoisData={whoisData}
          whoisStatus={whoisStatus}
          type={type}
          props={props}
        />
        <EnrichmentSnapshot
          oldData={mergeAPIEnrichmentData}
          statusOld={enrichmentStatus}
          newData={mergeAPINewEnrichmentData}
          statusNew={newEnrichmentStatus}
          whoisData={whoisData}
          whoisStatus={whoisStatus}
          fallbackData={whoisFallbackData}
          fallbackStatus={whoisFallbackStatus}
          type={type}
          props={props}
          openAllCollapse={openAllCollapse}
        />

        <Row gutter={24} className={cx('collapse_row')}>
          <Col xs={24}>
            <Collapse
              defaultActiveKey={['1']}
              activeKey={activeCollapseKey}
              expandIconPosition={'end'}
            >
              <Panel header={infoAttributesHeader()} key="1">
                <Row gutter={24}>
                  <Col xs={24} lg={12}>
                    {type === 'ipv4' && (
                      <>
                        <EnrichmentIpInformation
                          props={props}
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          oldData={mergeAPIEnrichmentData}
                          statusOld={enrichmentStatus}
                          parsedData={parsedIOC}
                        />
                        <EnrchmentAssociatedCert
                          history={props?.history}
                          oldData={mergeAPIEnrichmentData}
                          status={enrichmentStatus}
                          parsedData={parsedIOC}
                          props={props}
                        />
                      </>
                    )}
                    {type === 'domain' && (
                      <>
                        <EnrichmentDomainInformation
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          oldData={mergeAPIEnrichmentData}
                          statusOld={enrichmentStatus}
                          infraTag={domainInfraTags}
                          parsedData={parsedIOC}
                          infraTagStatus={infraTagStatus}
                          props={props}
                        />
                        <EnrichmentDnsRecords
                          history={props?.history}
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          // dnsRecords={dnsRecords}
                          // dnsStatus={dnsRecordsStatus}
                          ARecordsDomainEnrichmentData={
                            ARecordsDomainEnrichmentData
                          }
                          ARecordsDomainEnrichmentStatus={
                            ARecordsDomainEnrichmentStatus
                          }
                          AAAARecordsDomainEnrichmentData={
                            AAAARecordsDomainEnrichmentData
                          }
                          AAAARecordsDomainEnrichmentStatus={
                            AAAARecordsDomainEnrichmentStatus
                          }
                          CNAMERecordsDomainEnrichmentData={
                            CNAMERecordsDomainEnrichmentData
                          }
                          CNAMERecordsDomainEnrichmentStatus={
                            CNAMERecordsDomainEnrichmentStatus
                          }
                          MXRecordsDomainEnrichmentData={
                            MXRecordsDomainEnrichmentData
                          }
                          MXRecordsDomainEnrichmentStatus={
                            MXRecordsDomainEnrichmentStatus
                          }
                          NSRecordsDomainEnrichmentData={
                            NSRecordsDomainEnrichmentData
                          }
                          NSRecordsDomainEnrichmentStatus={
                            NSRecordsDomainEnrichmentStatus
                          }
                          SOARecordsDomainEnrichmentData={
                            SOARecordsDomainEnrichmentData
                          }
                          SOARecordsDomainEnrichmentStatus={
                            SOARecordsDomainEnrichmentStatus
                          }
                          TXTRecordsDomainEnrichmentData={
                            TXTRecordsDomainEnrichmentData
                          }
                          TXTRecordsDomainEnrichmentStatus={
                            TXTRecordsDomainEnrichmentStatus
                          }
                          ipDensity={ipDensityEnrichment}
                          ipDensityStatus={ipDensityEnrichmentStatus}
                          PTRLookup={ptrLookupEnrichment}
                          PTRLookupStatus={ptrLookupEnrichmentStatus}
                          type={type}
                          parsedData={parsedIOC}
                          props={props}
                        />
                      </>
                    )}
                  </Col>

                  <Col xs={24} lg={12}>
                    {type === 'ipv4' && (
                      <>
                        <EnrichmentDnsRecords
                          history={props?.history}
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          // dnsRecords={dnsRecords}
                          // dnsStatus={dnsRecordsStatus}
                          ipDensity={ipDensityEnrichment}
                          ipDensityStatus={ipDensityEnrichmentStatus}
                          PTRLookup={ptrLookupEnrichment}
                          PTRLookupStatus={ptrLookupEnrichmentStatus}
                          type={type}
                          parsedData={parsedIOC}
                          props={props}
                        />
                        <EnrichmentGeo
                          newData={mergeAPINewEnrichmentData}
                          status={newEnrichmentStatus}
                          parsedData={parsedIOC}
                        />
                      </>
                    )}
                    {type === 'domain' && (
                      <EnrichmentWhoisInformation
                        data={whoisData}
                        status={whoisStatus}
                        fallbackData={whoisFallbackData}
                        fallbackStatus={whoisFallbackStatus}
                        parsedData={parsedIOC}
                        whoisAge={
                          mergeAPINewEnrichmentData?.response?.domaininfo
                            ?.whois_age
                        }
                      />
                    )}
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Col>
        </Row>

        <Row className={cx(styles.attributes_row, 'collapse_row')}>
          <Col xs={24}>
            <Collapse
              defaultActiveKey={['2']}
              activeKey={activeCollapseKey}
              expandIconPosition={'end'}
            >
              <Panel header={attributesHeader()} key="2">
                <Row gutter={24}>
                  <Col xs={24} lg={12}>
                    {type === 'ipv4' && (
                      <>
                        <EnrichmentCuratedFeedHistory
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          type={type}
                          parsedData={parsedIOC}
                          availableFeeds={availableFeeds}
                          availableFeedsStatus={availableFeedsStatus}
                        />
                        <EnrichmentSubnetInformation
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          parsedData={parsedIOC}
                        />
                      </>
                    )}
                    {type === 'domain' && (
                      <>
                        <EnrichmentIpDiversity
                          history={props?.history}
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          parsedData={parsedIOC}
                          props={props}
                        />
                        <EnrichmentCuratedFeedHistory
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          type={type}
                          parsedData={parsedIOC}
                          availableFeeds={availableFeeds}
                          availableFeedsStatus={availableFeedsStatus}
                        />
                      </>
                    )}
                  </Col>
                  <Col xs={24} lg={12}>
                    {type === 'ipv4' && (
                      <>
                        <EnrichmentAsnInformation
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          parsedData={parsedIOC}
                        />
                        <EnrichmentIPReputation
                          newData={mergeAPINewEnrichmentData}
                          statusNew={newEnrichmentStatus}
                          parsedData={parsedIOC}
                        />
                      </>
                    )}
                    {type === 'domain' && (
                      <EnrichmentNameServerInformation
                        history={props?.history}
                        newData={mergeAPINewEnrichmentData}
                        statusNew={newEnrichmentStatus}
                        parsedData={parsedIOC}
                        props={props}
                      />
                    )}
                    <EnrichmentNameServerChanges
                      newData={mergeAPINewEnrichmentData}
                      statusNew={newEnrichmentStatus}
                      parsedData={parsedIOC}
                    />
                  </Col>
                  <Col xs={24}>
                    <EnrichmentCustomAttributes
                      oldData={mergeAPIEnrichmentData}
                      statusOld={enrichmentStatus}
                      statusNew={newEnrichmentStatus}
                      type={type}
                      parsedData={parsedIOC}
                    />
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Col>
        </Row>

        <Row className={cx(styles.sources_row, 'collapse_row')}>
          <Col xs={24}>
            <Collapse
              defaultActiveKey={['3']}
              activeKey={activeCollapseKey}
              expandIconPosition={'end'}
            >
              <Panel header={sourcesHeader()} key="3">
                <EnrichmentSources
                  oldData={mergeAPIEnrichmentData}
                  statusOld={enrichmentStatus}
                  type={type}
                  history={props.history}
                  parsedData={parsedIOC}
                  props={props}
                />
              </Panel>
            </Collapse>
          </Col>
        </Row>

        <Row className={cx(styles.sources_row, 'collapse_row')}>
          <Col xs={24}>
            <Collapse
              defaultActiveKey={['4']}
              activeKey={activeCollapseKey}
              expandIconPosition={'end'}
            >
              <Panel header={scanDataHeader()} key="4">
                <Row gutter={24}>
                  <Col xs={24} lg={12}>
                    <EnrichmentCertificates
                      newData={mergeAPINewEnrichmentData}
                      statusNew={newEnrichmentStatus}
                      type={type}
                      history={props?.history}
                      oldData={mergeAPIEnrichmentData}
                      parsedData={parsedIOC}
                      parsedIOCStatus={parsedIOCStatus}
                      props={props}
                    />
                    <EnrichmentHtml
                      newData={mergeAPINewEnrichmentData}
                      statusNew={newEnrichmentStatus}
                      type={type}
                      parsedData={parsedIOC}
                      props={props}
                    />
                  </Col>
                  <Col xs={24} lg={12}>
                    <EnrichmentJarm
                      newData={mergeAPINewEnrichmentData}
                      statusNew={newEnrichmentStatus}
                      type={type}
                      parsedData={parsedIOC}
                      props={props}
                    />
                    <EnrichmentFavicon
                      newData={mergeAPINewEnrichmentData}
                      statusNew={newEnrichmentStatus}
                      type={type}
                      parsedData={parsedIOC}
                      props={props}
                    />
                    <EnrichmentHeader
                      newData={mergeAPINewEnrichmentData}
                      statusNew={newEnrichmentStatus}
                      type={type}
                      parsedData={parsedIOC}
                    />
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </div>
    ) : (
      <PermissionDeniedPage />
    )
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default Enrichment;
